<template>
  <GridComponent
    id="personList"
    ref="_grid"
    :data-source="_dataManager1"
    :allow-paging="true"
    :allow-sorting="true"
    width="auto"
    :allow-reordering="true"
    :allow-resizing="true"
    :show-column-menu="false"
    :allow-text-wrap="true"
    :row-selected="onRowSelected"
    :row-deselected="onRowDeselected"
    :page-settings="_pageSettings"
    :action-failure="gridActionFailure"
  >
    <ColumnsDirective>
      <ColumnDirective
        header-text=""
        :template="'cTemplate'"
        width="28"
        :allow-sorting="false"
      >
        <template #cTemplate="{data}">
          <SogIcon
            v-show="data.insuranceId"
            icon="mdi-car"
          />
          <SogIcon
            v-show="data.ignore==='Y'"
            icon="mdi-close"
            class="cl"
          />
        </template>
      </ColumnDirective>
      <ColumnDirective
        field="insuranceNumber"
        header-text="VR.Nummer"
        :auto-fit="true"
      />
      <ColumnDirective
        field="evb"
        header-text="eVB/Form.Nr."
        :auto-fit="true"
      />
      <ColumnDirective
        field="versicherungsScheinnummer"
        header-text="GDV-VSNr"
        :auto-fit="true"
      />
      <ColumnDirective
        field="versicherungsBestaetigungsNummer"
        header-text="GDV-VBNr"
        :auto-fit="true"
      />
      <ColumnDirective
        field="datumVersicherungsBeginn"
        header-text="VR-Beginn"
        :auto-fit="true"
        format="dd.MM.yyyy"
        type="dateTime"
      />
      <ColumnDirective
        field="fahrzeugIdentifizierungsNummer"
        header-text="Fahrzeug Id-Nummer"
        :auto-fit="true"
      />
      <ColumnDirective
        field="kennzeichen"
        header-text="Kennzeichnen"
        :auto-fit="true"
      />
      <ColumnDirective
        field="kennzeichenDatumGueltigBis"
        header-text="gueltig Bis"
        :auto-fit="true"
        format="dd.MM.yyyy"
        type="dateTime"
      />
      <!--
            <ColumnDirective
              field="fahrzeugArt"
              header-text="Fahrzeugart"
              :auto-fit="true"
            />
      -->
      <ColumnDirective
        field="kennzeichenZeitpunktZuteilung"
        header-text="Zeitpunkt der Zuteilung"
        :auto-fit="true"
        format="dd.MM.yyyy HH:mm:ss"
        type="dateTime"
      />
      <ColumnDirective
        field="halterVorname"
        header-text="Halter"
        :auto-fit="true"
        :value-accessor="getFullName"
      />
      <ColumnDirective
        field="halterStrasse"
        header-text="Halteranschrift"
        :auto-fit="true"
        :value-accessor="getFullAddress"
      />
    </ColumnsDirective>
  </GridComponent>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {Api, gridActionFailure} from "@/shared/services/api";

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {DataManager} from "@syncfusion/ej2-data/src/manager";

const _url = Api.baseUrl + '/VehicleRegistrationList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}


const _dataManager1 = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})


const _emit = defineEmits<{ (e: 'selected', vehicleRegistrationId?: string): void }>()

function onRowSelected(args: any) {
  _emit("selected", args.data.id)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
}

function getFullName(field: string, data: any) {
  if (data['halterVorname'])
    return data['halterVorname'] + ' ' + data['halterNachname'];
  else
    return data['halterNachname'];
}

function getFullAddress(field: string, data: any,) {
  return data['halterStrasse'] + ' ' + data['halterHausnummer'] ?? "" + ' ' + data['halterPostleitzahl'] ?? "" + ' ' + data['halterWohnort'] + ' ' + data['halterStaat'];
}

function refresh() {
  _grid.value?.refresh()
}

defineExpose({
  adaptor: _adaptor, refresh
})

</script>

<style scoped>
.cl {
  color: #ff0000;
}

</style>
